import { DMCRectangle } from "../KObjects/DMCRectangle";
import { DMCText } from "../KObjects/DMCText";
import { DMCImage } from "../KObjects/DMCImage";
import { DMCVideo } from "../KObjects/DMCVideo";
import { DMCScrolling } from "../KObjects/DMCScrolling";
import { DMCCalendar } from "../KObjects/DMCCalendar";
import { DMCWeb } from "../KObjects/DMCWeb";
import { DMCWeather } from "../KObjects/DMCWeather";
import { DMCButton } from "../KObjects/DMCButton";

import store from "../../../store/store";

// Tools
const ft = require("../../Tools/FileTools");
const pathInfo = require("path");

export class ProjectLoader {
  constructor(controllerProject, userInfo, fileData, stage, containerSize, incorporate = true) {
    this.controllerProject = controllerProject;
    this.userInfo = userInfo;
    this.path =
      store.state.config.dirs.root + "temp/" + userInfo.socId + "/" + userInfo.userId + "/projectBeingLoaded/";
    this.zipPath = fileData.savePath;
    this.projectName = fileData.projectName;
    this.incorporate = incorporate;
    this.stage = stage;
    this.containerSize = containerSize;
  }

  createNewElement(DMCObject, creationController, incorporate = true) {
    return new Promise((resolve, reject) => {
      const type = DMCObject.name.split(" ")[0];
      let object;

      // Convert konvaObject if necessary
      try {
        let properties = DMCObject.konvaObject;

        if (typeof properties !== "object") {
          properties = JSON.parse(DMCObject.konvaObject);
        }

        DMCObject.konvaObject = properties;
      } catch (err) {
        console.error("Error reading object properties:", err);
      }

      switch (type) {
        case "Rect":
          object = new DMCRectangle().load(creationController, DMCObject, incorporate);
          break;
        case "Button":
          object = new DMCButton().load(creationController, DMCObject, incorporate);
          break;
        case "Text":
          object = new DMCText().load(creationController, DMCObject, incorporate);
          break;
        case "Weather":
          object = new DMCWeather().load(creationController, DMCObject, incorporate);
          break;
        case "Web":
          object = new DMCWeb().load(creationController, DMCObject, incorporate);
          break;
        case "Image":
          object = new DMCImage().load(creationController, DMCObject, incorporate);
          break;
        case "pdf":
          object = new DMCImage().load(creationController, DMCObject, incorporate);
          break;
        case "Video":
          object = new DMCVideo().load(creationController, DMCObject, incorporate);
          break;
        case "Calendar":
          object = new DMCCalendar().load(creationController, DMCObject, incorporate);
          break;
        case "Scrolling":
          object = new DMCScrolling().load(creationController, DMCObject, incorporate);
          break;
        case "rss":
          object = new DMCScrolling().load(creationController, DMCObject, incorporate);
          break;

        default:
          return reject("Error on schedule reader create new element : " + DMCObject);
      }

      return resolve(object);
    });
  }

  load() {
    return new Promise((resolve, reject) => {
      // TODO: NEED TO DELETE DIR BEFORE EXTRACT PREVENT KEEPING MEDIA MAYBE ADD IN EXPLORER EXTRACT PROJECT FUNCTIONS
      ft.remove(this.path + "media/")
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          // TODO: IN EXPLORER MAKE FUNCTION THAT EXTRACT + READ JSON
          ft.extract(store.state.config.dirs.root + this.zipPath, this.path)
            .then(() => {
              this.readProject()
                .then((data) => {
                  return resolve(data);
                })
                .catch((err) => {
                  console.error(err);
                  return reject("Error on read " + err);
                });
            })
            .catch((err) => {
              console.error(err);
              return reject("Error on extract " + err);
            });
        });
    });
  }

  loadElements(rawData) {
    try {
      let data = rawData;

      // If the data received are not of type object we try to parse json
      if (typeof rawData !== "object") {
        data = JSON.parse(rawData);
      }

      this.controllerProject.createCompleteController(this.stage, data.projectSize, this.projectName);

      // TODO: Save dir elsewhere + check if player not affected by this...
      const workingDir =
        store.state.config.dirs.root +
        "temp/" +
        this.userInfo.socId +
        "/" +
        this.userInfo.userId +
        "/projectBeingLoaded/media/";
      const salt = "?t=" + Date.now().toString();

      for (let element of Object.values(data.elements)) {
        // On objects we need to get all sources and make  a new array
        if (element.source !== undefined) {
          if (typeof element.source == "object") {
            element.source = element.source.map((media) => {
              const medianame = pathInfo.basename(media);
              return workingDir + medianame + salt;
            });
          } else {
            const medianame = pathInfo.basename(element.source);
            // Use decompressed media files instead mediacenter files
            element.source = workingDir + medianame + salt;
          }
        }

        this.createNewElement(element, this.controllerProject, this.incorporate)
          .then((object) => {
            //chargement des données de l'animation pour chaque animation enregistrée dans le project.json (refreshAnimation)
            for (let anim of Object.values(data.refreshAnimation)) {
              if (anim.id == object.name) {
                object.loadAnimation(anim.animation);
              }
            }
            this.controllerProject.elements[object.name] = object;
          })
          .catch((err) => {
            console.error(err);
          });
      }

      this.controllerProject.elementsNumber = data.elementsNumber;
      this.controllerProject.autoRescaleStage(this.containerSize);
      return Object.entries(data.elements);
    } catch (err) {
      console.error("Project json is not valid");
      console.error(err);
      return [];
    }
  }

  readProject() {
    const _this = this;
    return new Promise((resolve, reject) => {
      ft.read(this.path + "project.json")
        .then((data) => {
          if (typeof data == "string") data = JSON.parse(data); //les anciens projets sont renvoyés en string

          const loadedObjects = _this.loadElements(data);
          if (loadedObjects.length > 0) {
            return resolve(loadedObjects);
          } else {
            return reject("Error project is not valid or empty");
          }
        })
        .catch((err) => {
          console.error("Error reading project file:", err);
          return reject(err);
        });
    });
  }
}
